import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SuggestedPoint } from '../../../../interfaces/edit-route.response';
import { EditedPoint } from '../../../../interfaces/edit-route.interface';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatBottomSheetAddNewPointOrReplacePointData } from 'src/app/interfaces/mat.interface';
import { CardService } from './services';
import { FooterComponent, HeaderComponent, MainComponent } from './components';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    TranslateModule,
    HeaderComponent,
    MainComponent,
    FooterComponent
  ],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardComponent {
  // Input signals
  public indexCard: InputSignal<number> = input.required<number>();
  public point: InputSignal<SuggestedPoint> = input.required<SuggestedPoint>();
  
  // Injected services
  private _cardService = inject(CardService);
  private _matBottomSheetData: MatBottomSheetAddNewPointOrReplacePointData = inject(MAT_BOTTOM_SHEET_DATA);
  
  // Methods
  /**
   * Handles the card click event and delegates to the service
   */
  public handleClick(point: SuggestedPoint | EditedPoint): void {
    this._cardService.handlePointSelection(point, this._matBottomSheetData);
  }
}
